import React, { Component } from "react";
import { connect } from "react-redux";
import Slider from "react-slick";
import Lightbox from "react-images";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <img
        src={require("../assets/right.png")}
        alt="next"
        style={{ marginTop: "-25px" }}
      />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style
      }}
      onClick={onClick}
    >
      <img
        src={require("../assets/left.png")}
        alt="previous"
        style={{ marginTop: "-25px" }}
      />
    </div>
  );
}

class Latest extends Component {
  constructor() {
    super();
    this.state = {
      lightbox01: false,
      lightbox02: false,
      lightbox03: false,
      lightbox04: false,
      lightbox05: false,
      lightbox06: false,
      lightbox07: false,
      lightbox08: false,
      lightbox09: false,
      lightbox10: false,
      lightbox11: false,
      lightbox12: false,
      lightbox13: false,
      lightbox14: false
    };
  }

  render() {
    var settings = {
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 10000,
      cssEase: "linear",
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 0,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
      <div>
        <br />
        <h6>
          <p>
            <font color="#689BDF">Best celebrity doppelgangers</font>
          </p>
        </h6>
        <br />
        <Slider {...settings}>
          <div>
            <center>
              <div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/fem/mila-kunis/thumb-20120712_mila_kunis_comic-con_cropped.jpg"
                    alt="milakunis"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox01: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/fem/mila-kunis/20120712_mila_kunis_comic-con_cropped.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox01}
                    onClickImage={() => this.setState({ lightbox01: false })}
                    onClose={() => this.setState({ lightbox01: false })}
                    showImageCount={false}
                  />
                </div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/fem/sarah-hyland/thumb-sarah_hyland_at_2015_paleyfest.jpg"
                    alt="sarahhyland"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox02: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/fem/sarah-hyland/sarah_hyland_at_2015_paleyfest.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox02}
                    onClickImage={() => this.setState({ lightbox02: false })}
                    onClose={() => this.setState({ lightbox02: false })}
                    showImageCount={false}
                  />
                </div>
              </div>
              <h6>
                <p>Mila Kunis - Sarah Hyland</p>
              </h6>
            </center>
          </div>
          <div>
            <center>
              <div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/mas/ian-somerhalder/thumb-ian_somerhalder_by_gage_skidmore_5.jpg"
                    alt="iansomerhalder"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox03: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/mas/ian-somerhalder/ian_somerhalder_by_gage_skidmore_5.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox03}
                    onClickImage={() => this.setState({ lightbox03: false })}
                    onClose={() => this.setState({ lightbox03: false })}
                    showImageCount={false}
                  />
                </div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/mas/chace-crawford/thumb-chace_crawford_2.jpg"
                    alt="chacecrawford"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox04: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/mas/chace-crawford/chace_crawford_2.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox04}
                    onClickImage={() => this.setState({ lightbox04: false })}
                    onClose={() => this.setState({ lightbox04: false })}
                    showImageCount={false}
                  />
                </div>
              </div>
              <h6>
                <p>Ian Somerhalder - Chace Crawford</p>
              </h6>
            </center>
          </div>
          <div>
            <center>
              <div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/fem/melinda-clarke/thumb-melindaclarketiffsept2011.jpg"
                    alt="malindaclarke"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox05: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/fem/melinda-clarke/melindaclarketiffsept2011.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox05}
                    onClickImage={() => this.setState({ lightbox05: false })}
                    onClose={() => this.setState({ lightbox05: false })}
                    showImageCount={false}
                  />
                </div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/fem/emma-stone/thumb-emma-stone-photo-call.jpg"
                    alt="emmastone"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox06: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/fem/emma-stone/emma-stone-photo-call.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox06}
                    onClickImage={() => this.setState({ lightbox06: false })}
                    onClose={() => this.setState({ lightbox06: false })}
                    showImageCount={false}
                  />
                </div>
              </div>
              <h6>
                <p>Melinda Clarke - Emma Stone</p>
              </h6>
            </center>
          </div>
          <div>
            <center>
              <div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/mas/James-Franco/thumb-James_Franco_2007_Spiderman_3_premiere.jpg"
                    alt="jamesfranco"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox07: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/mas/James-Franco/James_Franco_2007_Spiderman_3_premiere.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox07}
                    onClickImage={() => this.setState({ lightbox07: false })}
                    onClose={() => this.setState({ lightbox07: false })}
                    showImageCount={false}
                  />
                </div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/mas/james-dean/thumb-james_dean_in_rebel_without_a_cause.jpg"
                    alt="jamesdean"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox08: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/mas/james-dean/james_dean_in_rebel_without_a_cause.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox08}
                    onClickImage={() => this.setState({ lightbox08: false })}
                    onClose={() => this.setState({ lightbox08: false })}
                    showImageCount={false}
                  />
                </div>
              </div>
              <h6>
                <p>James Franco - James Dean</p>
              </h6>
            </center>
          </div>
          <div>
            <center>
              <div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/fem/katy-perry/thumb-katy_perry_unicef_2012.jpg"
                    alt="katyperry"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox09: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/fem/katy-perry/katy_perry_unicef_2012.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox09}
                    onClickImage={() => this.setState({ lightbox09: false })}
                    onClose={() => this.setState({ lightbox09: false })}
                    showImageCount={false}
                  />
                </div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/fem/zooey-deschanel/thumb-flickr_-_genevieve719_-_zooey_deschanel_8_cropped_.jpg"
                    alt="zooeydeschanel"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox10: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/fem/zooey-deschanel/flickr_-_genevieve719_-_zooey_deschanel_8_cropped_.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox10}
                    onClickImage={() => this.setState({ lightbox10: false })}
                    onClose={() => this.setState({ lightbox10: false })}
                    showImageCount={false}
                  />
                </div>
              </div>
              <h6>
                <p>Katy Perry - Zooey Deschanel</p>
              </h6>
            </center>
          </div>
          <div>
            <center>
              <div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/mas/elijah-woods/elijah_wood_ff_2014.jpg"
                    alt="elijahwood"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox11: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/mas/elijah-woods/elijah_wood_ff_2014.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox11}
                    onClickImage={() => this.setState({ lightbox11: false })}
                    onClose={() => this.setState({ lightbox11: false })}
                    showImageCount={false}
                  />
                </div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/mas/daniel-radcliffe/thumb-daniel_radcliffe_2009.jpg"
                    alt="danielradcliffe"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox12: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/mas/daniel-radcliffe/daniel_radcliffe_2009.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox12}
                    onClickImage={() => this.setState({ lightbox12: false })}
                    onClose={() => this.setState({ lightbox12: false })}
                    showImageCount={false}
                  />
                </div>
              </div>
              <h6>
                <p>Elijah Wood - Daniel Radcliffe</p>
              </h6>
            </center>
          </div>
          <div>
            <center>
              <div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/fem/margot-robbie/thumb-margot_robbie_cropped_.jpg"
                    alt="margotrobbie"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox13: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/fem/margot-robbie/margot_robbie_cropped_.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox13}
                    onClickImage={() => this.setState({ lightbox13: false })}
                    onClose={() => this.setState({ lightbox13: false })}
                    showImageCount={false}
                  />
                </div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src="https://img.lookaliker.com/img/fem/jaime-pressly/thumb-jaime_pressly_side2march09.jpg"
                    alt="jaimepressly"
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() => this.setState({ lightbox14: true })}
                  />
                  <Lightbox
                    images={[
                      {
                        src:
                          "https://img.lookaliker.com/img/fem/jaime-pressly/jaime_pressly_side2march09.jpg",
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox14}
                    onClickImage={() => this.setState({ lightbox14: false })}
                    onClose={() => this.setState({ lightbox14: false })}
                    showImageCount={false}
                  />
                </div>
              </div>
              <h6>
                <p>Margot Robbie - Jaime Pressly</p>
              </h6>
            </center>
          </div>
        </Slider>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Latest);



// WEBPACK FOOTER //
// ./src/components/Latest.js